import React from 'react';
import _get from 'lodash/get';
import { Field, useFormikContext } from 'formik';

import Error from './Error';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const FIELD_NAME = 'title';

const Title = () => {
  const { errors, touched } = useFormikContext();
  const { t } = useTranslation(['events']);
  const showError = !!_get(errors, FIELD_NAME) && !!_get(touched, FIELD_NAME);

  return (
    <>
      <Field
        id="title"
        name={FIELD_NAME}
        className={classNames(
          'w-full mt-4 p-1 text-2xl font-semibold rounded-md placeholder:text-gray-500',
          showError ? 'bg-red-100' : 'bg-transparent'
        )}
        placeholder={t('events:host.eventNamePlaceholder')}
      />

      {showError && <Error error={_get(errors, FIELD_NAME)} />}
    </>
  );
};

export default Title;
